export default {"src":"/_next/static/media/fatorsugar.dfa58385.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};